import { render, staticRenderFns } from "./mypage-navigation.vue?vue&type=template&id=bba0cf72&"
import script from "./mypage-navigation.vue?vue&type=script&lang=js&"
export * from "./mypage-navigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports